import { Input } from '../../ui/input';

export const InsuranceStep = ({ formData, update }) => (
  <div className="space-y-5" data-testid="intake-step-insurance">
    <h2 className="text-2xl font-bold text-darkBrown mb-2">Insurance Information</h2>
    <p className="text-gray-500 text-sm">Leave blank if self-pay or uninsured.</p>
    <div className="grid md:grid-cols-2 gap-4">
      <div className="space-y-1">
        <label className="text-sm font-medium text-darkBrown">Insurance Provider</label>
        <Input data-testid="intake-insurance-provider" value={formData.insuranceProvider} onChange={(e) => update('insuranceProvider', e.target.value)} placeholder="e.g. Blue Cross Blue Shield" />
      </div>
      <div className="space-y-1">
        <label className="text-sm font-medium text-darkBrown">Policy Number</label>
        <Input value={formData.policyNumber} onChange={(e) => update('policyNumber', e.target.value)} placeholder="Policy #" />
      </div>
    </div>
    <div className="grid md:grid-cols-2 gap-4">
      <div className="space-y-1">
        <label className="text-sm font-medium text-darkBrown">Group Number</label>
        <Input value={formData.groupNumber} onChange={(e) => update('groupNumber', e.target.value)} placeholder="Group #" />
      </div>
      <div className="space-y-1">
        <label className="text-sm font-medium text-darkBrown">Subscriber Name</label>
        <Input value={formData.subscriberName} onChange={(e) => update('subscriberName', e.target.value)} placeholder="If different from patient" />
      </div>
    </div>
    <div className="space-y-1">
      <label className="text-sm font-medium text-darkBrown">Subscriber Date of Birth</label>
      <Input type="date" value={formData.subscriberDOB} onChange={(e) => update('subscriberDOB', e.target.value)} />
    </div>
  </div>
);
